export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The built-in `Decimal` scalar type. */
  Decimal: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
};

export type Advertisement = {
  __typename?: 'Advertisement';
  html: Scalars['String'];
  position: Scalars['Int'];
};

export type AdvertisementAmp = {
  __typename?: 'AdvertisementAMP';
  htmls?: Maybe<Array<Scalars['String']>>;
  resources?: Maybe<Scalars['String']>;
};

export type Advertising = {
  __typename?: 'Advertising';
  amp?: Maybe<AdvertisementAmp>;
  footer?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  landing336?: Maybe<Scalars['String']>;
  left?: Maybe<Array<Advertisement>>;
  nativeGrid?: Maybe<Array<Advertisement>>;
  right?: Maybe<Array<Advertisement>>;
  standard_336?: Maybe<Array<Advertisement>>;
  standard_728?: Maybe<Array<Advertisement>>;
  sticky_ad?: Maybe<Array<Advertisement>>;
};

export type AdvertisingDfp = {
  __typename?: 'AdvertisingDFP';
  adId?: Maybe<Scalars['String']>;
  adSizes?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Alert = {
  __typename?: 'Alert';
  city?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  search?: Maybe<Scalars['String']>;
};

export type AlertsEmail = {
  __typename?: 'AlertsEmail';
  alerts?: Maybe<Array<Maybe<Alert>>>;
  email?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  newsletter: Scalars['Boolean'];
};

export type Article = {
  __typename?: 'Article';
  catalogId: Scalars['Int'];
  id: Scalars['Int'];
  page: Scalars['Int'];
};

export type ArticleFilterInput = {
  and?: InputMaybe<Array<ArticleFilterInput>>;
  catalogId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ArticleFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
};

export type AssignedRetailer = {
  __typename?: 'AssignedRetailer';
  id: Scalars['Int'];
  name: Scalars['String'];
  online: Scalars['Boolean'];
};

export type AssignedRetailerFilterInput = {
  and?: InputMaybe<Array<AssignedRetailerFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  online?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<AssignedRetailerFilterInput>>;
};

export type Autocomplete = {
  __typename?: 'Autocomplete';
  brands?: Maybe<Array<AutocompleteItem>>;
  categories?: Maybe<Array<AutocompleteItem>>;
  exactMatch?: Maybe<Array<AutocompleteItem>>;
  malls?: Maybe<Array<AutocompleteItem>>;
  products?: Maybe<Array<AutocompleteItem>>;
  retailers?: Maybe<Array<AutocompleteItem>>;
  specials?: Maybe<Array<AutocompleteItem>>;
};

export type AutocompleteItem = {
  __typename?: 'AutocompleteItem';
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  seoName: Scalars['String'];
  type: Scalars['Int'];
};

export type AutocompleteProduct = {
  __typename?: 'AutocompleteProduct';
  category?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Banner = {
  __typename?: 'Banner';
  desktop?: Maybe<BannerItem>;
  mobile?: Maybe<BannerItem>;
};

export type BannerItem = {
  __typename?: 'BannerItem';
  event?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image: Scalars['String'];
  target?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  h1: Scalars['String'];
  h1Short: Scalars['String'];
  links?: Maybe<Array<Link>>;
  logo?: Maybe<Link>;
  navigationLinks?: Maybe<Array<Link>>;
  title: Scalars['String'];
};

export type CarrefourSliderInput = {
  cookieStoreId?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['String']>;
  promo?: InputMaybe<Scalars['String']>;
  selectedRetailer?: InputMaybe<Scalars['Int']>;
  storeId?: InputMaybe<Scalars['Int']>;
  userUrl?: InputMaybe<Scalars['String']>;
};

export type CarrefourSliderOutput = {
  __typename?: 'CarrefourSliderOutput';
  baseUrlViewer?: Maybe<Scalars['String']>;
  catalog?: Maybe<SliderCatalog>;
  catalogId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  htmls?: Maybe<SliderHtmls>;
  integration?: Maybe<Scalars['String']>;
  openButton?: Maybe<Scalars['String']>;
  openCatalog?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  redirectionUrl?: Maybe<Scalars['String']>;
  selectedCustomer?: Maybe<Scalars['Int']>;
  store?: Maybe<SliderStore>;
  storeCatalogs?: Maybe<Array<SliderStoreCatalog>>;
  storeId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type CarrefourSliderPromoInput = {
  cookieStoreId?: InputMaybe<Scalars['Int']>;
  geo?: InputMaybe<Scalars['Boolean']>;
  promo?: InputMaybe<Scalars['String']>;
  userUrl?: InputMaybe<Scalars['String']>;
};

export type CarrefourSliderPromoOutput = {
  __typename?: 'CarrefourSliderPromoOutput';
  redirectUrl?: Maybe<Scalars['String']>;
};

export type Catalog = {
  __typename?: 'Catalog';
  affinity: Scalars['Int'];
  articles?: Maybe<Array<Article>>;
  articlesByTag?: Maybe<Array<Article>>;
  category?: Maybe<Synonym>;
  clientViewerUrl?: Maybe<Scalars['String']>;
  confirmType: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  endPublicationDate: Scalars['DateTime'];
  folderImage: Scalars['String'];
  geograficalArea?: Maybe<GeograficalArea>;
  height: Scalars['Int'];
  highlighteds?: Maybe<Array<HighlightedCatalog>>;
  id: Scalars['Int'];
  iframeHeader: Scalars['Boolean'];
  iframeViewer: Scalars['Boolean'];
  imageTemplate: Scalars['String'];
  impressionPixel?: Maybe<Scalars['String']>;
  isDynamic: Scalars['Boolean'];
  isStoreAnnouncement?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  manufacturer: Scalars['Boolean'];
  maxDistance: Scalars['Int'];
  modelName?: Maybe<Scalars['String']>;
  moreCatalogs: Scalars['Int'];
  nearestStoreDistance?: Maybe<Scalars['Float']>;
  online: Scalars['Boolean'];
  onlyOnline: Scalars['Boolean'];
  openBehind: Scalars['Boolean'];
  pageNumber: Scalars['Int'];
  promo?: Maybe<Scalars['String']>;
  promoCoupons?: Maybe<Array<Scalars['Int']>>;
  publicationDate: Scalars['DateTime'];
  retailer?: Maybe<Retailer>;
  retailerId: Scalars['Int'];
  retailerName: Scalars['String'];
  retailers?: Maybe<Array<AssignedRetailer>>;
  score: Scalars['Int'];
  search?: Maybe<SearchInfo>;
  sections?: Maybe<Array<Section>>;
  shopfullyId: Scalars['Int'];
  shopfullyPdfUrl?: Maybe<Scalars['String']>;
  showDetails: Scalars['Boolean'];
  showProductsSection: Scalars['Boolean'];
  startDate: Scalars['DateTime'];
  store0: Scalars['Int'];
  storeUrl?: Maybe<Scalars['String']>;
  storeUrlType?: Maybe<Scalars['String']>;
  subPromo?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  topCities?: Maybe<Array<Scalars['String']>>;
  totalPages: Scalars['Int'];
  uuid: Scalars['String'];
  visibleApps: Scalars['Boolean'];
  visibleMobile: Scalars['Boolean'];
  visibleWeb: Scalars['Boolean'];
  width: Scalars['Int'];
  withAds: Scalars['Boolean'];
};

/** A connection to a list of items. */
export type CatalogConnection = {
  __typename?: 'CatalogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CatalogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Catalog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CatalogEdge = {
  __typename?: 'CatalogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Catalog;
};

export type CatalogFilterInput = {
  affinity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<CatalogFilterInput>>;
  articles?: InputMaybe<ListFilterInputTypeOfArticleFilterInput>;
  articlesByTag?: InputMaybe<ListFilterInputTypeOfArticleFilterInput>;
  category?: InputMaybe<SynonymFilterInput>;
  clientViewerUrl?: InputMaybe<StringOperationFilterInput>;
  confirmType?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  endPublicationDate?: InputMaybe<DateTimeOperationFilterInput>;
  folderImage?: InputMaybe<StringOperationFilterInput>;
  geograficalArea?: InputMaybe<GeograficalAreaFilterInput>;
  height?: InputMaybe<IntOperationFilterInput>;
  highlighteds?: InputMaybe<ListFilterInputTypeOfHighlightedCatalogFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  iframeHeader?: InputMaybe<BooleanOperationFilterInput>;
  iframeViewer?: InputMaybe<BooleanOperationFilterInput>;
  imageTemplate?: InputMaybe<StringOperationFilterInput>;
  impressionPixel?: InputMaybe<StringOperationFilterInput>;
  isDynamic?: InputMaybe<BooleanOperationFilterInput>;
  isStoreAnnouncement?: InputMaybe<StringOperationFilterInput>;
  languageCode?: InputMaybe<StringOperationFilterInput>;
  manufacturer?: InputMaybe<BooleanOperationFilterInput>;
  maxDistance?: InputMaybe<IntOperationFilterInput>;
  modelName?: InputMaybe<StringOperationFilterInput>;
  moreCatalogs?: InputMaybe<IntOperationFilterInput>;
  nearestStoreDistance?: InputMaybe<FloatOperationFilterInput>;
  online?: InputMaybe<BooleanOperationFilterInput>;
  onlyOnline?: InputMaybe<BooleanOperationFilterInput>;
  openBehind?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CatalogFilterInput>>;
  pageNumber?: InputMaybe<IntOperationFilterInput>;
  promo?: InputMaybe<StringOperationFilterInput>;
  promoCoupons?: InputMaybe<ListIntOperationFilterInput>;
  publicationDate?: InputMaybe<DateTimeOperationFilterInput>;
  retailer?: InputMaybe<RetailerFilterInput>;
  retailerId?: InputMaybe<IntOperationFilterInput>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  retailers?: InputMaybe<ListFilterInputTypeOfAssignedRetailerFilterInput>;
  score?: InputMaybe<IntOperationFilterInput>;
  search?: InputMaybe<SearchInfoFilterInput>;
  sections?: InputMaybe<ListFilterInputTypeOfSectionFilterInput>;
  shopfullyId?: InputMaybe<IntOperationFilterInput>;
  shopfullyPdfUrl?: InputMaybe<StringOperationFilterInput>;
  showDetails?: InputMaybe<BooleanOperationFilterInput>;
  showProductsSection?: InputMaybe<BooleanOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  store0?: InputMaybe<IntOperationFilterInput>;
  storeUrl?: InputMaybe<StringOperationFilterInput>;
  storeUrlType?: InputMaybe<StringOperationFilterInput>;
  subPromo?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  topCities?: InputMaybe<ListStringOperationFilterInput>;
  totalPages?: InputMaybe<IntOperationFilterInput>;
  uuid?: InputMaybe<StringOperationFilterInput>;
  visibleApps?: InputMaybe<BooleanOperationFilterInput>;
  visibleMobile?: InputMaybe<BooleanOperationFilterInput>;
  visibleWeb?: InputMaybe<BooleanOperationFilterInput>;
  width?: InputMaybe<IntOperationFilterInput>;
  withAds?: InputMaybe<BooleanOperationFilterInput>;
};

export type CatalogSortInput = {
  affinity?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SynonymSortInput>;
  clientViewerUrl?: InputMaybe<SortEnumType>;
  confirmType?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  endPublicationDate?: InputMaybe<SortEnumType>;
  folderImage?: InputMaybe<SortEnumType>;
  geograficalArea?: InputMaybe<GeograficalAreaSortInput>;
  height?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  iframeHeader?: InputMaybe<SortEnumType>;
  iframeViewer?: InputMaybe<SortEnumType>;
  imageTemplate?: InputMaybe<SortEnumType>;
  impressionPixel?: InputMaybe<SortEnumType>;
  isDynamic?: InputMaybe<SortEnumType>;
  isStoreAnnouncement?: InputMaybe<SortEnumType>;
  languageCode?: InputMaybe<SortEnumType>;
  manufacturer?: InputMaybe<SortEnumType>;
  maxDistance?: InputMaybe<SortEnumType>;
  modelName?: InputMaybe<SortEnumType>;
  moreCatalogs?: InputMaybe<SortEnumType>;
  nearestStoreDistance?: InputMaybe<SortEnumType>;
  online?: InputMaybe<SortEnumType>;
  onlyOnline?: InputMaybe<SortEnumType>;
  openBehind?: InputMaybe<SortEnumType>;
  pageNumber?: InputMaybe<SortEnumType>;
  promo?: InputMaybe<SortEnumType>;
  publicationDate?: InputMaybe<SortEnumType>;
  retailer?: InputMaybe<RetailerSortInput>;
  retailerId?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  score?: InputMaybe<SortEnumType>;
  search?: InputMaybe<SearchInfoSortInput>;
  shopfullyId?: InputMaybe<SortEnumType>;
  shopfullyPdfUrl?: InputMaybe<SortEnumType>;
  showDetails?: InputMaybe<SortEnumType>;
  showProductsSection?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  store0?: InputMaybe<SortEnumType>;
  storeUrl?: InputMaybe<SortEnumType>;
  storeUrlType?: InputMaybe<SortEnumType>;
  subPromo?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  totalPages?: InputMaybe<SortEnumType>;
  uuid?: InputMaybe<SortEnumType>;
  visibleApps?: InputMaybe<SortEnumType>;
  visibleMobile?: InputMaybe<SortEnumType>;
  visibleWeb?: InputMaybe<SortEnumType>;
  width?: InputMaybe<SortEnumType>;
  withAds?: InputMaybe<SortEnumType>;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['Int'];
  imageUrl: Scalars['String'];
  inflectedName: Scalars['String'];
  link?: Maybe<Link>;
  name: Scalars['String'];
  seoName: Scalars['String'];
  shopfullyId: Scalars['Int'];
  shortName: Scalars['String'];
  typeNoCity: Scalars['Int'];
  url?: Maybe<Link>;
};

export type CategoryFilterInput = {
  and?: InputMaybe<Array<CategoryFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  inflectedName?: InputMaybe<StringOperationFilterInput>;
  link?: InputMaybe<LinkFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CategoryFilterInput>>;
  seoName?: InputMaybe<StringOperationFilterInput>;
  shopfullyId?: InputMaybe<IntOperationFilterInput>;
  shortName?: InputMaybe<StringOperationFilterInput>;
  typeNoCity?: InputMaybe<IntOperationFilterInput>;
  url?: InputMaybe<LinkFilterInput>;
};

export type CategorySortInput = {
  id?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  inflectedName?: InputMaybe<SortEnumType>;
  link?: InputMaybe<LinkSortInput>;
  name?: InputMaybe<SortEnumType>;
  seoName?: InputMaybe<SortEnumType>;
  shopfullyId?: InputMaybe<SortEnumType>;
  shortName?: InputMaybe<SortEnumType>;
  typeNoCity?: InputMaybe<SortEnumType>;
  url?: InputMaybe<LinkSortInput>;
};

export type CategoryTags = {
  __typename?: 'CategoryTags';
  category?: Maybe<Category>;
  tags?: Maybe<TagConnection>;
};


export type CategoryTagsTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type CategoryTagsConnection = {
  __typename?: 'CategoryTagsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CategoryTagsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CategoryTags>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CategoryTagsEdge = {
  __typename?: 'CategoryTagsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CategoryTags;
};

export type City = {
  __typename?: 'City';
  contentType?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  inflected: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  link?: Maybe<Link>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  seoName: Scalars['String'];
};

/** A connection to a list of items. */
export type CityConnection = {
  __typename?: 'CityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<City>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CityEdge = {
  __typename?: 'CityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: City;
};

export type CitySortInput = {
  contentType?: InputMaybe<SortEnumType>;
  distance?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inflected?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  link?: InputMaybe<LinkSortInput>;
  longitude?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  seoName?: InputMaybe<SortEnumType>;
};

export type Cookie = {
  __typename?: 'Cookie';
  group: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  provider: Scalars['String'];
  regexName: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type CreateAlertInput = {
  category?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mail: Scalars['String'];
  search: Scalars['String'];
};

export type CreateAlertsInput = {
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mail: Scalars['String'];
  search: Array<Scalars['String']>;
};

export type Customization = {
  __typename?: 'Customization';
  key: Scalars['String'];
  value?: Maybe<Scalars['Any']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type DeleteAlertInput = {
  city?: InputMaybe<Scalars['String']>;
  hash: Scalars['String'];
  id: Scalars['Int'];
  search: Scalars['String'];
};

export type Description = {
  __typename?: 'Description';
  htmls?: Maybe<Array<Scalars['String']>>;
  links?: Maybe<Array<Link>>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Faq = {
  __typename?: 'Faq';
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
};

export type Footer = {
  __typename?: 'Footer';
  about?: Maybe<Array<LinkGroup>>;
  apps?: Maybe<Array<Link>>;
  copyright: Scalars['String'];
  legalNotice?: Maybe<Link>;
  socials?: Maybe<Array<Link>>;
};

export type GeograficalArea = {
  __typename?: 'GeograficalArea';
  id: Scalars['Int'];
  idType: Scalars['Int'];
  latitudeNE: Scalars['Float'];
  latitudeSW: Scalars['Float'];
  longitudeNE: Scalars['Float'];
  longitudeSW: Scalars['Float'];
  type: Scalars['Int'];
};

export type GeograficalAreaFilterInput = {
  and?: InputMaybe<Array<GeograficalAreaFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  idType?: InputMaybe<IntOperationFilterInput>;
  latitudeNE?: InputMaybe<FloatOperationFilterInput>;
  latitudeSW?: InputMaybe<FloatOperationFilterInput>;
  longitudeNE?: InputMaybe<FloatOperationFilterInput>;
  longitudeSW?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<GeograficalAreaFilterInput>>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type GeograficalAreaSortInput = {
  id?: InputMaybe<SortEnumType>;
  idType?: InputMaybe<SortEnumType>;
  latitudeNE?: InputMaybe<SortEnumType>;
  latitudeSW?: InputMaybe<SortEnumType>;
  longitudeNE?: InputMaybe<SortEnumType>;
  longitudeSW?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type HighLighted = {
  __typename?: 'HighLighted';
  brands?: Maybe<Array<Link>>;
  cities?: Maybe<Array<Link>>;
  lightedProducts?: Maybe<Array<LinkGroup>>;
  products?: Maybe<Array<Link>>;
  specialProducts?: Maybe<Array<Link>>;
  title?: Maybe<Scalars['String']>;
};

export type HighLightedCities = {
  __typename?: 'HighLightedCities';
  links?: Maybe<Array<Link>>;
};

export type HighlightedCatalog = {
  __typename?: 'HighlightedCatalog';
  catalogId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  page: Scalars['Int'];
};

export type HighlightedCatalogFilterInput = {
  and?: InputMaybe<Array<HighlightedCatalogFilterInput>>;
  catalogId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<HighlightedCatalogFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type LaunchViewerInput = {
  city?: InputMaybe<Scalars['String']>;
  customUrl?: InputMaybe<Scalars['Int']>;
  customerStore?: InputMaybe<Scalars['String']>;
  distance?: InputMaybe<Scalars['Int']>;
  folder?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  integration?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  platform?: InputMaybe<Scalars['String']>;
  promo?: InputMaybe<Scalars['String']>;
  retailer?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  store?: InputMaybe<Scalars['Int']>;
  userUrl?: InputMaybe<Scalars['String']>;
};

export type LaunchViewerResult = {
  __typename?: 'LaunchViewerResult';
  catalog?: Maybe<Catalog>;
  isValidMagicCatalog: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type LeftMenu = {
  __typename?: 'LeftMenu';
  links?: Maybe<Array<MenuLink>>;
  title?: Maybe<Scalars['String']>;
  titleLink?: Maybe<Link>;
};

export type Link = {
  __typename?: 'Link';
  image?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  pageType?: Maybe<Scalars['String']>;
  params?: Maybe<Array<LinkParam>>;
  searchType?: Maybe<SearchType>;
  url: Scalars['String'];
};

/** A connection to a list of items. */
export type LinkConnection = {
  __typename?: 'LinkConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LinkEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Link>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type LinkEdge = {
  __typename?: 'LinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Link;
};

export type LinkFilterInput = {
  and?: InputMaybe<Array<LinkFilterInput>>;
  image?: InputMaybe<StringOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LinkFilterInput>>;
  pageType?: InputMaybe<StringOperationFilterInput>;
  params?: InputMaybe<ListFilterInputTypeOfLinkParamFilterInput>;
  searchType?: InputMaybe<NullableOfSearchTypeOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type LinkGroup = {
  __typename?: 'LinkGroup';
  description?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Link>>;
  name: Scalars['String'];
};

export type LinkParam = {
  __typename?: 'LinkParam';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type LinkParamFilterInput = {
  and?: InputMaybe<Array<LinkParamFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LinkParamFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type LinkSortInput = {
  image?: InputMaybe<SortEnumType>;
  label?: InputMaybe<SortEnumType>;
  pageType?: InputMaybe<SortEnumType>;
  searchType?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

export type LinkViewerInput = {
  article?: InputMaybe<Scalars['Int']>;
  catalog?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['Boolean']>;
  integration?: InputMaybe<Scalars['String']>;
  refPageType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  view?: InputMaybe<Scalars['String']>;
};

export type LinkViewerResult = {
  __typename?: 'LinkViewerResult';
  catalog?: Maybe<Catalog>;
  city?: Maybe<City>;
  linkType?: Maybe<Scalars['String']>;
  pageType?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ListFilterInputTypeOfArticleFilterInput = {
  all?: InputMaybe<ArticleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ArticleFilterInput>;
  some?: InputMaybe<ArticleFilterInput>;
};

export type ListFilterInputTypeOfAssignedRetailerFilterInput = {
  all?: InputMaybe<AssignedRetailerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AssignedRetailerFilterInput>;
  some?: InputMaybe<AssignedRetailerFilterInput>;
};

export type ListFilterInputTypeOfHighlightedCatalogFilterInput = {
  all?: InputMaybe<HighlightedCatalogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<HighlightedCatalogFilterInput>;
  some?: InputMaybe<HighlightedCatalogFilterInput>;
};

export type ListFilterInputTypeOfLinkParamFilterInput = {
  all?: InputMaybe<LinkParamFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LinkParamFilterInput>;
  some?: InputMaybe<LinkParamFilterInput>;
};

export type ListFilterInputTypeOfOfferChipFilterInput = {
  all?: InputMaybe<OfferChipFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OfferChipFilterInput>;
  some?: InputMaybe<OfferChipFilterInput>;
};

export type ListFilterInputTypeOfOfferLinkFilterInput = {
  all?: InputMaybe<OfferLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OfferLinkFilterInput>;
  some?: InputMaybe<OfferLinkFilterInput>;
};

export type ListFilterInputTypeOfOfferTagBoxSiblingFilterInput = {
  all?: InputMaybe<OfferTagBoxSiblingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OfferTagBoxSiblingFilterInput>;
  some?: InputMaybe<OfferTagBoxSiblingFilterInput>;
};

export type ListFilterInputTypeOfOfferTagPageItemFilterInput = {
  all?: InputMaybe<OfferTagPageItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OfferTagPageItemFilterInput>;
  some?: InputMaybe<OfferTagPageItemFilterInput>;
};

export type ListFilterInputTypeOfSectionFilterInput = {
  all?: InputMaybe<SectionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SectionFilterInput>;
  some?: InputMaybe<SectionFilterInput>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type Mall = {
  __typename?: 'Mall';
  address: Scalars['String'];
  city: Scalars['String'];
  distance: Scalars['Float'];
  hasOffers: Scalars['Boolean'];
  id: Scalars['Int'];
  latitude: Scalars['Float'];
  logo: Scalars['String'];
  logo2: Scalars['String'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  province: Scalars['String'];
  seoName: Scalars['String'];
  suburb?: Maybe<Scalars['String']>;
  top: Scalars['String'];
  url?: Maybe<Link>;
  web?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

/** A connection to a list of items. */
export type MallConnection = {
  __typename?: 'MallConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MallEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mall>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MallEdge = {
  __typename?: 'MallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Mall;
};

export type MallInfo = {
  __typename?: 'MallInfo';
  address?: Maybe<Scalars['String']>;
  addressLink?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  latitude: Scalars['Float'];
  logo?: Maybe<Scalars['String']>;
  longitude: Scalars['Float'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  privateTransport?: Maybe<Scalars['String']>;
  publicTransport?: Maybe<Scalars['String']>;
  specialTime?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  transportDetails?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type MallSortInput = {
  address?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  distance?: InputMaybe<SortEnumType>;
  hasOffers?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  logo?: InputMaybe<SortEnumType>;
  logo2?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  province?: InputMaybe<SortEnumType>;
  seoName?: InputMaybe<SortEnumType>;
  suburb?: InputMaybe<SortEnumType>;
  top?: InputMaybe<SortEnumType>;
  url?: InputMaybe<LinkSortInput>;
  web?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export type MenuLink = {
  __typename?: 'MenuLink';
  image?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  pageType?: Maybe<Scalars['String']>;
  params?: Maybe<Array<LinkParam>>;
  searchType?: Maybe<SearchType>;
  subLinks: Array<Link>;
  url: Scalars['String'];
};

export type Metatags = {
  __typename?: 'Metatags';
  amp?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  h1: Scalars['String'];
  h1Short: Scalars['String'];
  keywords: Scalars['String'];
  male: Scalars['Boolean'];
  robotsIndex: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  ConfirmAlerts: Scalars['Boolean'];
  CreateAlert: Scalars['Boolean'];
  CreateAlerts: Scalars['Boolean'];
  CreateSavedPage: Scalars['Boolean'];
  DeleteAlerts: Scalars['Boolean'];
  DeleteSavedPage: Scalars['Boolean'];
  DeleteUserApp: Scalars['Boolean'];
  NewsletterState: Scalars['Boolean'];
  NotifyUserData: Scalars['Boolean'];
  UserData: Scalars['Boolean'];
};


export type MutationConfirmAlertsArgs = {
  hash: Scalars['String'];
  user: Scalars['String'];
};


export type MutationCreateAlertArgs = {
  input: CreateAlertInput;
};


export type MutationCreateAlertsArgs = {
  input: CreateAlertsInput;
};


export type MutationCreateSavedPageArgs = {
  input: SavedPageInput;
};


export type MutationDeleteAlertsArgs = {
  input: Array<DeleteAlertInput>;
  reason?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteSavedPageArgs = {
  input: SavedPageInput;
};


export type MutationDeleteUserAppArgs = {
  appUserId: Scalars['Long'];
};


export type MutationNewsletterStateArgs = {
  activate: Scalars['Boolean'];
  hash: Scalars['String'];
};


export type MutationNotifyUserDataArgs = {
  action: UserDataAction;
  mail: Scalars['String'];
};


export type MutationUserDataArgs = {
  action: UserDataAction;
  hash: Scalars['String'];
  usuTiendeo: Scalars['String'];
};

export type NullableOfSearchTypeOperationFilterInput = {
  eq?: InputMaybe<SearchType>;
  in?: InputMaybe<Array<InputMaybe<SearchType>>>;
  neq?: InputMaybe<SearchType>;
  nin?: InputMaybe<Array<InputMaybe<SearchType>>>;
};

export type Offer = {
  __typename?: 'Offer';
  brandId: Scalars['Int'];
  catalogId: Scalars['Int'];
  catalogPage?: Maybe<OfferCatalogPage>;
  daysSincePublication: Scalars['Int'];
  discountValue: Scalars['Float'];
  endDate: Scalars['DateTime'];
  id: Scalars['Int'];
  offerDates?: Maybe<OfferDates>;
  page: Scalars['Int'];
  position: Scalars['Int'];
  priceValue: Scalars['Float'];
  productId: Scalars['Int'];
  retailer?: Maybe<Retailer>;
  retailerId: Scalars['Int'];
  retailerName: Scalars['String'];
  sale?: Maybe<OfferSale>;
  shopfullyId: Scalars['String'];
  startDate: Scalars['DateTime'];
  stringId: Scalars['String'];
  tagBox?: Maybe<OfferTagBox>;
  tagPage?: Maybe<OfferTagPage>;
  type: OfferType;
};

export type OfferBrandData = {
  __typename?: 'OfferBrandData';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type OfferBrandDataFilterInput = {
  and?: InputMaybe<Array<OfferBrandDataFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OfferBrandDataFilterInput>>;
};

export type OfferBrandDataSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type OfferCatalogPage = {
  __typename?: 'OfferCatalogPage';
  catalog?: Maybe<Catalog>;
  catalogId: Scalars['Int'];
  dates?: Maybe<OfferDates>;
  id: Scalars['Int'];
  modelName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  page: Scalars['Int'];
  retailer?: Maybe<Retailer>;
  retailerId: Scalars['Int'];
  retailerName: Scalars['String'];
  stringId?: Maybe<Scalars['String']>;
};

export type OfferCatalogPageFilterInput = {
  and?: InputMaybe<Array<OfferCatalogPageFilterInput>>;
  catalogId?: InputMaybe<IntOperationFilterInput>;
  dates?: InputMaybe<OfferDatesFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  modelName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OfferCatalogPageFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
  retailerId?: InputMaybe<IntOperationFilterInput>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  stringId?: InputMaybe<StringOperationFilterInput>;
};

export type OfferCatalogPageSortInput = {
  catalogId?: InputMaybe<SortEnumType>;
  dates?: InputMaybe<OfferDatesSortInput>;
  id?: InputMaybe<SortEnumType>;
  modelName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  page?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  stringId?: InputMaybe<SortEnumType>;
};

export type OfferChip = {
  __typename?: 'OfferChip';
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OfferChipFilterInput = {
  and?: InputMaybe<Array<OfferChipFilterInput>>;
  or?: InputMaybe<Array<OfferChipFilterInput>>;
  text?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type OfferConnection = {
  __typename?: 'OfferConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OfferEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Offer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type OfferDates = {
  __typename?: 'OfferDates';
  daysSincePublication: Scalars['Int'];
  daysToExpire: Scalars['Int'];
  endDate: Scalars['DateTime'];
  expiresIn: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type OfferDatesFilterInput = {
  and?: InputMaybe<Array<OfferDatesFilterInput>>;
  daysSincePublication?: InputMaybe<IntOperationFilterInput>;
  daysToExpire?: InputMaybe<IntOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  expiresIn?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OfferDatesFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type OfferDatesSortInput = {
  daysSincePublication?: InputMaybe<SortEnumType>;
  daysToExpire?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  expiresIn?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type OfferEdge = {
  __typename?: 'OfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Offer;
};

export type OfferFilterInput = {
  and?: InputMaybe<Array<OfferFilterInput>>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  catalogId?: InputMaybe<IntOperationFilterInput>;
  catalogPage?: InputMaybe<OfferCatalogPageFilterInput>;
  daysSincePublication?: InputMaybe<IntOperationFilterInput>;
  discountValue?: InputMaybe<FloatOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OfferFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
  position?: InputMaybe<IntOperationFilterInput>;
  priceValue?: InputMaybe<FloatOperationFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  retailerId?: InputMaybe<IntOperationFilterInput>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  sale?: InputMaybe<OfferSaleFilterInput>;
  shopfullyId?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  stringId?: InputMaybe<StringOperationFilterInput>;
  tagBox?: InputMaybe<OfferTagBoxFilterInput>;
  tagPage?: InputMaybe<OfferTagPageFilterInput>;
  type?: InputMaybe<OfferTypeOperationFilterInput>;
};

export type OfferLink = {
  __typename?: 'OfferLink';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type OfferLinkFilterInput = {
  and?: InputMaybe<Array<OfferLinkFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OfferLinkFilterInput>>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type OfferLinkSortInput = {
  name?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

export type OfferProduct = {
  __typename?: 'OfferProduct';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** A connection to a list of items. */
export type OfferProductConnection = {
  __typename?: 'OfferProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OfferProductEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OfferProduct>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type OfferProductData = {
  __typename?: 'OfferProductData';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type OfferProductDataFilterInput = {
  and?: InputMaybe<Array<OfferProductDataFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OfferProductDataFilterInput>>;
};

export type OfferProductDataSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type OfferProductEdge = {
  __typename?: 'OfferProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OfferProduct;
};

export type OfferProductFilterInput = {
  and?: InputMaybe<Array<OfferProductFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OfferProductFilterInput>>;
};

export type OfferProductSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type OfferSale = {
  __typename?: 'OfferSale';
  dates?: Maybe<OfferDates>;
  descriptionText?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  discountValue: Scalars['Float'];
  freeShipping: Scalars['Boolean'];
  id: Scalars['Int'];
  imageTemplates?: Maybe<Array<Scalars['String']>>;
  images?: Maybe<Array<Scalars['String']>>;
  link?: Maybe<OfferLink>;
  modelName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  oldPrice?: Maybe<Scalars['String']>;
  oldPriceValue: Scalars['Float'];
  price?: Maybe<Scalars['String']>;
  priceValue: Scalars['Float'];
  retailer?: Maybe<Retailer>;
  retailerId: Scalars['Int'];
  retailerName: Scalars['String'];
  shippingCosts?: Maybe<Scalars['String']>;
  stringId?: Maybe<Scalars['String']>;
  tag?: Maybe<OfferTag>;
};

export type OfferSaleFilterInput = {
  and?: InputMaybe<Array<OfferSaleFilterInput>>;
  dates?: InputMaybe<OfferDatesFilterInput>;
  descriptionText?: InputMaybe<StringOperationFilterInput>;
  discount?: InputMaybe<StringOperationFilterInput>;
  discountCode?: InputMaybe<StringOperationFilterInput>;
  discountValue?: InputMaybe<FloatOperationFilterInput>;
  freeShipping?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  imageTemplates?: InputMaybe<ListStringOperationFilterInput>;
  images?: InputMaybe<ListStringOperationFilterInput>;
  link?: InputMaybe<OfferLinkFilterInput>;
  modelName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  oldPrice?: InputMaybe<StringOperationFilterInput>;
  oldPriceValue?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<OfferSaleFilterInput>>;
  price?: InputMaybe<StringOperationFilterInput>;
  priceValue?: InputMaybe<FloatOperationFilterInput>;
  retailerId?: InputMaybe<IntOperationFilterInput>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  shippingCosts?: InputMaybe<StringOperationFilterInput>;
  stringId?: InputMaybe<StringOperationFilterInput>;
  tag?: InputMaybe<OfferTagFilterInput>;
};

export type OfferSaleSortInput = {
  dates?: InputMaybe<OfferDatesSortInput>;
  descriptionText?: InputMaybe<SortEnumType>;
  discount?: InputMaybe<SortEnumType>;
  discountCode?: InputMaybe<SortEnumType>;
  discountValue?: InputMaybe<SortEnumType>;
  freeShipping?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  link?: InputMaybe<OfferLinkSortInput>;
  modelName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  oldPrice?: InputMaybe<SortEnumType>;
  oldPriceValue?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  priceValue?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  shippingCosts?: InputMaybe<SortEnumType>;
  stringId?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<OfferTagSortInput>;
};

export type OfferSortInput = {
  brandId?: InputMaybe<SortEnumType>;
  catalogId?: InputMaybe<SortEnumType>;
  catalogPage?: InputMaybe<OfferCatalogPageSortInput>;
  daysSincePublication?: InputMaybe<SortEnumType>;
  discountValue?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  page?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  priceValue?: InputMaybe<SortEnumType>;
  productId?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  sale?: InputMaybe<OfferSaleSortInput>;
  shopfullyId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  stringId?: InputMaybe<SortEnumType>;
  tagBox?: InputMaybe<OfferTagBoxSortInput>;
  tagPage?: InputMaybe<OfferTagPageSortInput>;
  type?: InputMaybe<SortEnumType>;
};

export type OfferTag = {
  __typename?: 'OfferTag';
  brand?: Maybe<OfferBrandData>;
  product?: Maybe<OfferProductData>;
};

export type OfferTagBox = {
  __typename?: 'OfferTagBox';
  buttonText?: Maybe<Scalars['String']>;
  catalog?: Maybe<Catalog>;
  catalogId: Scalars['Int'];
  chips?: Maybe<Array<OfferChip>>;
  dates?: Maybe<OfferDates>;
  descriptionText?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  discountValue: Scalars['Float'];
  extraTitle?: Maybe<Scalars['String']>;
  freeShipping: Scalars['Boolean'];
  highlightedText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image: Scalars['String'];
  imageTemplate: Scalars['String'];
  imageTemplates?: Maybe<Array<Scalars['String']>>;
  images?: Maybe<Array<Scalars['String']>>;
  infoPrice?: Maybe<Scalars['String']>;
  legalText?: Maybe<Scalars['String']>;
  links?: Maybe<Array<OfferLink>>;
  lowerRightPoint?: Maybe<TagBoxPoint>;
  modelName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  oldPrice?: Maybe<Scalars['String']>;
  oldPriceValue: Scalars['Float'];
  page: Scalars['Int'];
  /** @deprecated Use ParentStringId instead */
  parentId?: Maybe<Scalars['Int']>;
  parentStringId?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  price?: Maybe<Scalars['String']>;
  priceValue: Scalars['Float'];
  promoCoupon?: Maybe<TagBoxPromoCouponInfo>;
  promotion?: Maybe<Scalars['String']>;
  quantity1: Scalars['Float'];
  quantity2: Scalars['Float'];
  retailer?: Maybe<Retailer>;
  retailerId: Scalars['Int'];
  retailerName: Scalars['String'];
  shippingCosts?: Maybe<Scalars['String']>;
  shopfullyId: Scalars['String'];
  shortLegalText?: Maybe<Scalars['String']>;
  siblingIds?: Maybe<Array<Scalars['String']>>;
  siblingPosition?: Maybe<Scalars['Int']>;
  siblings?: Maybe<Array<OfferTagBoxSibling>>;
  sku?: Maybe<Scalars['String']>;
  stringId?: Maybe<Scalars['String']>;
  tag?: Maybe<OfferTag>;
  temperature: Scalars['Int'];
  type: TagBoxType;
  unit?: Maybe<Scalars['String']>;
  unitPrice: Scalars['Float'];
  upperLeftPoint?: Maybe<TagBoxPoint>;
  url?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type OfferTagBoxConnection = {
  __typename?: 'OfferTagBoxConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OfferTagBoxEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OfferTagBox>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OfferTagBoxEdge = {
  __typename?: 'OfferTagBoxEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: OfferTagBox;
};

export type OfferTagBoxFilterInput = {
  and?: InputMaybe<Array<OfferTagBoxFilterInput>>;
  buttonText?: InputMaybe<StringOperationFilterInput>;
  catalogId?: InputMaybe<IntOperationFilterInput>;
  chips?: InputMaybe<ListFilterInputTypeOfOfferChipFilterInput>;
  dates?: InputMaybe<OfferDatesFilterInput>;
  descriptionText?: InputMaybe<StringOperationFilterInput>;
  discount?: InputMaybe<StringOperationFilterInput>;
  discountValue?: InputMaybe<FloatOperationFilterInput>;
  extraTitle?: InputMaybe<StringOperationFilterInput>;
  freeShipping?: InputMaybe<BooleanOperationFilterInput>;
  highlightedText?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  image?: InputMaybe<StringOperationFilterInput>;
  imageTemplate?: InputMaybe<StringOperationFilterInput>;
  imageTemplates?: InputMaybe<ListStringOperationFilterInput>;
  images?: InputMaybe<ListStringOperationFilterInput>;
  infoPrice?: InputMaybe<StringOperationFilterInput>;
  legalText?: InputMaybe<StringOperationFilterInput>;
  links?: InputMaybe<ListFilterInputTypeOfOfferLinkFilterInput>;
  lowerRightPoint?: InputMaybe<TagBoxPointFilterInput>;
  modelName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  oldPrice?: InputMaybe<StringOperationFilterInput>;
  oldPriceValue?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<OfferTagBoxFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  parentStringId?: InputMaybe<StringOperationFilterInput>;
  position?: InputMaybe<IntOperationFilterInput>;
  price?: InputMaybe<StringOperationFilterInput>;
  priceValue?: InputMaybe<FloatOperationFilterInput>;
  promoCoupon?: InputMaybe<TagBoxPromoCouponInfoFilterInput>;
  promotion?: InputMaybe<StringOperationFilterInput>;
  quantity1?: InputMaybe<FloatOperationFilterInput>;
  quantity2?: InputMaybe<FloatOperationFilterInput>;
  retailerId?: InputMaybe<IntOperationFilterInput>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  shippingCosts?: InputMaybe<StringOperationFilterInput>;
  shopfullyId?: InputMaybe<StringOperationFilterInput>;
  shortLegalText?: InputMaybe<StringOperationFilterInput>;
  siblingIds?: InputMaybe<ListStringOperationFilterInput>;
  siblingPosition?: InputMaybe<IntOperationFilterInput>;
  siblings?: InputMaybe<ListFilterInputTypeOfOfferTagBoxSiblingFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  stringId?: InputMaybe<StringOperationFilterInput>;
  tag?: InputMaybe<OfferTagFilterInput>;
  temperature?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<TagBoxTypeOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInput>;
  unitPrice?: InputMaybe<FloatOperationFilterInput>;
  upperLeftPoint?: InputMaybe<TagBoxPointFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type OfferTagBoxSibling = {
  __typename?: 'OfferTagBoxSibling';
  buttonText?: Maybe<Scalars['String']>;
  catalog?: Maybe<Catalog>;
  catalogId: Scalars['Int'];
  chips?: Maybe<Array<OfferChip>>;
  dates?: Maybe<OfferDates>;
  descriptionText?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  discountValue: Scalars['Float'];
  extraTitle?: Maybe<Scalars['String']>;
  freeShipping: Scalars['Boolean'];
  highlightedText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image: Scalars['String'];
  imageTemplate: Scalars['String'];
  imageTemplates?: Maybe<Array<Scalars['String']>>;
  images?: Maybe<Array<Scalars['String']>>;
  infoPrice?: Maybe<Scalars['String']>;
  legalText?: Maybe<Scalars['String']>;
  links?: Maybe<Array<OfferLink>>;
  lowerRightPoint?: Maybe<TagBoxPoint>;
  modelName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  oldPrice?: Maybe<Scalars['String']>;
  oldPriceValue: Scalars['Float'];
  page: Scalars['Int'];
  position: Scalars['Int'];
  price?: Maybe<Scalars['String']>;
  priceValue: Scalars['Float'];
  promoCoupon?: Maybe<TagBoxPromoCouponInfo>;
  promotion?: Maybe<Scalars['String']>;
  quantity1: Scalars['Float'];
  quantity2: Scalars['Float'];
  retailer?: Maybe<Retailer>;
  retailerId: Scalars['Int'];
  retailerName: Scalars['String'];
  shippingCosts?: Maybe<Scalars['String']>;
  shopfullyId: Scalars['String'];
  shortLegalText?: Maybe<Scalars['String']>;
  siblingPosition?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  stringId?: Maybe<Scalars['String']>;
  tag?: Maybe<OfferTag>;
  temperature: Scalars['Int'];
  type: TagBoxType;
  unit?: Maybe<Scalars['String']>;
  unitPrice: Scalars['Float'];
  upperLeftPoint?: Maybe<TagBoxPoint>;
  url?: Maybe<Scalars['String']>;
};

export type OfferTagBoxSiblingFilterInput = {
  and?: InputMaybe<Array<OfferTagBoxSiblingFilterInput>>;
  buttonText?: InputMaybe<StringOperationFilterInput>;
  catalogId?: InputMaybe<IntOperationFilterInput>;
  chips?: InputMaybe<ListFilterInputTypeOfOfferChipFilterInput>;
  dates?: InputMaybe<OfferDatesFilterInput>;
  descriptionText?: InputMaybe<StringOperationFilterInput>;
  discount?: InputMaybe<StringOperationFilterInput>;
  discountValue?: InputMaybe<FloatOperationFilterInput>;
  extraTitle?: InputMaybe<StringOperationFilterInput>;
  freeShipping?: InputMaybe<BooleanOperationFilterInput>;
  highlightedText?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  image?: InputMaybe<StringOperationFilterInput>;
  imageTemplate?: InputMaybe<StringOperationFilterInput>;
  imageTemplates?: InputMaybe<ListStringOperationFilterInput>;
  images?: InputMaybe<ListStringOperationFilterInput>;
  infoPrice?: InputMaybe<StringOperationFilterInput>;
  legalText?: InputMaybe<StringOperationFilterInput>;
  links?: InputMaybe<ListFilterInputTypeOfOfferLinkFilterInput>;
  lowerRightPoint?: InputMaybe<TagBoxPointFilterInput>;
  modelName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  oldPrice?: InputMaybe<StringOperationFilterInput>;
  oldPriceValue?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<OfferTagBoxSiblingFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
  position?: InputMaybe<IntOperationFilterInput>;
  price?: InputMaybe<StringOperationFilterInput>;
  priceValue?: InputMaybe<FloatOperationFilterInput>;
  promoCoupon?: InputMaybe<TagBoxPromoCouponInfoFilterInput>;
  promotion?: InputMaybe<StringOperationFilterInput>;
  quantity1?: InputMaybe<FloatOperationFilterInput>;
  quantity2?: InputMaybe<FloatOperationFilterInput>;
  retailerId?: InputMaybe<IntOperationFilterInput>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  shippingCosts?: InputMaybe<StringOperationFilterInput>;
  shopfullyId?: InputMaybe<StringOperationFilterInput>;
  shortLegalText?: InputMaybe<StringOperationFilterInput>;
  siblingPosition?: InputMaybe<IntOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  stringId?: InputMaybe<StringOperationFilterInput>;
  tag?: InputMaybe<OfferTagFilterInput>;
  temperature?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<TagBoxTypeOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInput>;
  unitPrice?: InputMaybe<FloatOperationFilterInput>;
  upperLeftPoint?: InputMaybe<TagBoxPointFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type OfferTagBoxSortInput = {
  buttonText?: InputMaybe<SortEnumType>;
  catalogId?: InputMaybe<SortEnumType>;
  dates?: InputMaybe<OfferDatesSortInput>;
  descriptionText?: InputMaybe<SortEnumType>;
  discount?: InputMaybe<SortEnumType>;
  discountValue?: InputMaybe<SortEnumType>;
  extraTitle?: InputMaybe<SortEnumType>;
  freeShipping?: InputMaybe<SortEnumType>;
  highlightedText?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  image?: InputMaybe<SortEnumType>;
  imageTemplate?: InputMaybe<SortEnumType>;
  infoPrice?: InputMaybe<SortEnumType>;
  legalText?: InputMaybe<SortEnumType>;
  lowerRightPoint?: InputMaybe<TagBoxPointSortInput>;
  modelName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  oldPrice?: InputMaybe<SortEnumType>;
  oldPriceValue?: InputMaybe<SortEnumType>;
  page?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  parentStringId?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  priceValue?: InputMaybe<SortEnumType>;
  promoCoupon?: InputMaybe<TagBoxPromoCouponInfoSortInput>;
  promotion?: InputMaybe<SortEnumType>;
  quantity1?: InputMaybe<SortEnumType>;
  quantity2?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  shippingCosts?: InputMaybe<SortEnumType>;
  shopfullyId?: InputMaybe<SortEnumType>;
  shortLegalText?: InputMaybe<SortEnumType>;
  siblingPosition?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  stringId?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<OfferTagSortInput>;
  temperature?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
  unitPrice?: InputMaybe<SortEnumType>;
  upperLeftPoint?: InputMaybe<TagBoxPointSortInput>;
  url?: InputMaybe<SortEnumType>;
};

export type OfferTagFilterInput = {
  and?: InputMaybe<Array<OfferTagFilterInput>>;
  brand?: InputMaybe<OfferBrandDataFilterInput>;
  or?: InputMaybe<Array<OfferTagFilterInput>>;
  product?: InputMaybe<OfferProductDataFilterInput>;
};

export type OfferTagPage = {
  __typename?: 'OfferTagPage';
  catalog?: Maybe<Catalog>;
  catalogId: Scalars['Int'];
  dates?: Maybe<OfferDates>;
  id: Scalars['Int'];
  items?: Maybe<Array<OfferTagPageItem>>;
  modelName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  page: Scalars['Int'];
  retailer?: Maybe<Retailer>;
  retailerId: Scalars['Int'];
  retailerName: Scalars['String'];
  stringId?: Maybe<Scalars['String']>;
  tag?: Maybe<OfferTag>;
};

export type OfferTagPageFilterInput = {
  and?: InputMaybe<Array<OfferTagPageFilterInput>>;
  catalogId?: InputMaybe<IntOperationFilterInput>;
  dates?: InputMaybe<OfferDatesFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfOfferTagPageItemFilterInput>;
  modelName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OfferTagPageFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
  retailerId?: InputMaybe<IntOperationFilterInput>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  stringId?: InputMaybe<StringOperationFilterInput>;
  tag?: InputMaybe<OfferTagFilterInput>;
};

export type OfferTagPageItem = {
  __typename?: 'OfferTagPageItem';
  brandId: Scalars['Int'];
  firstPageWithResult: Scalars['Int'];
  name: Scalars['String'];
  number: Scalars['Int'];
  productId: Scalars['Int'];
};

export type OfferTagPageItemFilterInput = {
  and?: InputMaybe<Array<OfferTagPageItemFilterInput>>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  firstPageWithResult?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OfferTagPageItemFilterInput>>;
  productId?: InputMaybe<IntOperationFilterInput>;
};

export type OfferTagPageSortInput = {
  catalogId?: InputMaybe<SortEnumType>;
  dates?: InputMaybe<OfferDatesSortInput>;
  id?: InputMaybe<SortEnumType>;
  modelName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  page?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  stringId?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<OfferTagSortInput>;
};

export type OfferTagSortInput = {
  brand?: InputMaybe<OfferBrandDataSortInput>;
  product?: InputMaybe<OfferProductDataSortInput>;
};

export enum OfferType {
  Catalogpage = 'CATALOGPAGE',
  Sale = 'SALE',
  Tagbox = 'TAGBOX',
  Tagpage = 'TAGPAGE'
}

export type OfferTypeOperationFilterInput = {
  eq?: InputMaybe<OfferType>;
  in?: InputMaybe<Array<OfferType>>;
  neq?: InputMaybe<OfferType>;
  nin?: InputMaybe<Array<OfferType>>;
};

export type OriginInfo = {
  __typename?: 'OriginInfo';
  integration?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PageInfoDto = {
  __typename?: 'PageInfoDTO';
  amp?: Maybe<Scalars['String']>;
  category?: Maybe<Category>;
  city?: Maybe<City>;
  deepLink?: Maybe<Scalars['String']>;
  filter?: Maybe<Search>;
  link?: Maybe<Link>;
  originInfo?: Maybe<OriginInfo>;
  profilingBlocks?: Maybe<Array<Scalars['String']>>;
  retailer?: Maybe<Retailer>;
  search?: Maybe<Search>;
  storeId?: Maybe<Scalars['Int']>;
  suburb?: Maybe<Suburb>;
  withAds: Scalars['Boolean'];
};

export type PromoCoupon = {
  __typename?: 'PromoCoupon';
  amount?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  eans?: Maybe<Array<Scalars['String']>>;
  endDate: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageURL?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  manufacturerId: Scalars['Int'];
  publicationEndDate: Scalars['DateTime'];
  publicationStartDate: Scalars['DateTime'];
  shortDescription?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['Int'];
  units?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type PromoCouponConnection = {
  __typename?: 'PromoCouponConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PromoCouponEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PromoCoupon>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PromoCouponEdge = {
  __typename?: 'PromoCouponEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: PromoCoupon;
};

export type PromoCouponSortInput = {
  amount?: InputMaybe<SortEnumType>;
  buttonText?: InputMaybe<SortEnumType>;
  discountType?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imageURL?: InputMaybe<SortEnumType>;
  longDescription?: InputMaybe<SortEnumType>;
  manufacturerId?: InputMaybe<SortEnumType>;
  publicationEndDate?: InputMaybe<SortEnumType>;
  publicationStartDate?: InputMaybe<SortEnumType>;
  shortDescription?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  units?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

export type ProviderCookies = {
  __typename?: 'ProviderCookies';
  cookies?: Maybe<Array<Cookie>>;
  provider: Scalars['String'];
};

export type ProviderCookiesGroup = {
  __typename?: 'ProviderCookiesGroup';
  name: Scalars['String'];
  providers?: Maybe<Array<ProviderCookies>>;
};

export type Query = {
  __typename?: 'Query';
  Advertising?: Maybe<Advertising>;
  AdvertisingDFP?: Maybe<Array<AdvertisingDfp>>;
  Alerts?: Maybe<AlertsEmail>;
  Autocomplete: Autocomplete;
  AutocompleteCity: Array<AutocompleteItem>;
  AutocompleteProduct: Array<AutocompleteProduct>;
  AutocompleteProvinces: Array<AutocompleteItem>;
  AutocompleteRetailer: Array<AutocompleteItem>;
  AutomaticDescription?: Maybe<Description>;
  Banner?: Maybe<Banner>;
  Breadcrumb?: Maybe<Breadcrumb>;
  BreadcrumbStoreDetail?: Maybe<Breadcrumb>;
  CarrefourSliderInfo?: Maybe<CarrefourSliderOutput>;
  CarrefourSliderPromoInput: CarrefourSliderPromoOutput;
  Cashback?: Maybe<PromoCouponConnection>;
  Catalog?: Maybe<Catalog>;
  Catalogs?: Maybe<CatalogConnection>;
  CatalogsByCity?: Maybe<CatalogConnection>;
  CatalogsByIds?: Maybe<CatalogConnection>;
  CatalogsByLatLon?: Maybe<CatalogConnection>;
  CatalogsCategory?: Maybe<CatalogConnection>;
  CatalogsNoCity?: Maybe<CatalogConnection>;
  CatalogsRelated?: Maybe<CatalogConnection>;
  CatalogsSpecials?: Maybe<CatalogConnection>;
  CatalogsTrending?: Maybe<CatalogConnection>;
  Categories?: Maybe<Array<Category>>;
  CategoriesAll: Array<Category>;
  CategoriesTags?: Maybe<CategoryTagsConnection>;
  Category: Category;
  CategoryById: Category;
  CategoryByName: Category;
  CategoryTags?: Maybe<CategoryTags>;
  Cities?: Maybe<CityConnection>;
  City?: Maybe<City>;
  Cookie: Array<ProviderCookiesGroup>;
  Customizations: Array<Customization>;
  Description?: Maybe<Description>;
  FAQ: Array<Maybe<Faq>>;
  Footer?: Maybe<Footer>;
  HighLighted?: Maybe<HighLighted>;
  HighLightedCities?: Maybe<HighLightedCities>;
  HighLightedSeasonals?: Maybe<SeasonalConnection>;
  InternationalSites: Array<Link>;
  LaunchViewer?: Maybe<LaunchViewerResult>;
  LeftMenu: Array<LeftMenu>;
  LeftMenuByLatLon: Array<LeftMenu>;
  LeftMenuStoreDetail: Array<LeftMenu>;
  LinkViewer?: Maybe<LinkViewerResult>;
  LinksRetailers: Array<Link>;
  LinksRetailersStoreDetail: Array<Link>;
  Mall: Mall;
  MallById: Mall;
  MallByName: Mall;
  MallInfo?: Maybe<MallInfo>;
  Malls?: Maybe<MallConnection>;
  Metatags?: Maybe<Metatags>;
  MetatagsStoreDetail?: Maybe<Metatags>;
  NavigationLinks?: Maybe<Array<Link>>;
  NavigationLinksStoreDetail?: Maybe<Array<Link>>;
  NearestCities?: Maybe<CityConnection>;
  NearestCity: City;
  NearestMallsByCity?: Maybe<MallConnection>;
  NearestMallsByLatLon?: Maybe<MallConnection>;
  NearestStores?: Maybe<StoreConnection>;
  NearestStoresByCity?: Maybe<StoreConnection>;
  NearestStoresByLatLon?: Maybe<StoreConnection>;
  NearestStoresByStore?: Maybe<StoreConnection>;
  Offer?: Maybe<Offer>;
  OfferCatalogPage: Offer;
  OfferProducts?: Maybe<OfferProductConnection>;
  OfferTagBox?: Maybe<Offer>;
  Offers?: Maybe<OfferConnection>;
  OffersByCatalog?: Maybe<OfferConnection>;
  OffersRelated?: Maybe<OfferConnection>;
  PageInfo: PageInfoDto;
  PageInfoStoreDetail: PageInfoDto;
  Retailer: Retailer;
  RetailerById: Retailer;
  RetailerByName: Retailer;
  Retailers?: Maybe<RetailerConnection>;
  Robots: RobotsTxt;
  Seasonal: Seasonal;
  SeasonalById: Seasonal;
  SeasonalByName: Seasonal;
  Seasonals?: Maybe<SeasonalConnection>;
  ShoppingListOffers?: Maybe<OfferConnection>;
  ShoppingListOffersProducts?: Maybe<LinkConnection>;
  Sitemap: Array<SitemapItem>;
  SliderPageInfo: SliderPageInfoOutput;
  SliderScriptInfo: SliderScriptInfoOutput;
  SpecialProducts?: Maybe<LinkConnection>;
  StatsData?: Maybe<StatsData>;
  StatsMetadata: StatsMetadata;
  Store?: Maybe<Store>;
  Stores?: Maybe<StoreConnection>;
  StoresByCatalog?: Maybe<StoreConnection>;
  StoresByCatalogLatLon?: Maybe<StoreConnection>;
  StoresByCity?: Maybe<StoreConnection>;
  StoresByLatLon?: Maybe<StoreConnection>;
  StoresNoCity?: Maybe<StoreNoCityConnection>;
  Tabs: Array<Link>;
  TagBoxOffersByCatalog?: Maybe<OfferTagBoxConnection>;
  TagBrand: TagBrand;
  TagBrandById: TagBrand;
  TagBrandByName: TagBrand;
  TagProduct: TagProduct;
  TagProductById: TagProduct;
  TagProductByName: TagProduct;
  Tags?: Maybe<TagConnection>;
  TiendeoInYourCity?: Maybe<TiendeoInYourCity>;
  TopCities?: Maybe<CityConnection>;
  TopMalls?: Maybe<MallConnection>;
  TopMallsByLatLon?: Maybe<MallConnection>;
  TopTags?: Maybe<TagConnection>;
  Url?: Maybe<Link>;
  UrlByCity?: Maybe<Link>;
  UrlByLatLon?: Maybe<Link>;
  UrlStoreDetail?: Maybe<Link>;
};


export type QueryAdvertisingArgs = {
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryAdvertisingDfpArgs = {
  city?: InputMaybe<Scalars['String']>;
  integration?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryAlertsArgs = {
  hash: Scalars['String'];
};


export type QueryAutocompleteArgs = {
  city?: InputMaybe<Scalars['String']>;
  maxResults?: InputMaybe<Scalars['Int']>;
  phrase: Scalars['String'];
};


export type QueryAutocompleteCityArgs = {
  maxResults?: InputMaybe<Scalars['Int']>;
  phrase: Scalars['String'];
};


export type QueryAutocompleteProductArgs = {
  maxResults?: InputMaybe<Scalars['Int']>;
  phrase: Scalars['String'];
};


export type QueryAutocompleteProvincesArgs = {
  maxResults?: InputMaybe<Scalars['Int']>;
  phrase: Scalars['String'];
};


export type QueryAutocompleteRetailerArgs = {
  maxResults?: InputMaybe<Scalars['Int']>;
  phrase: Scalars['String'];
};


export type QueryAutomaticDescriptionArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryBannerArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBreadcrumbArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryBreadcrumbStoreDetailArgs = {
  storeId: Scalars['Int'];
};


export type QueryCarrefourSliderInfoArgs = {
  input: CarrefourSliderInput;
};


export type QueryCarrefourSliderPromoInputArgs = {
  input: CarrefourSliderPromoInput;
};


export type QueryCashbackArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PromoCouponSortInput>>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryCatalogArgs = {
  id: Scalars['Int'];
  origin?: InputMaybe<Scalars['String']>;
};


export type QueryCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CatalogSortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CatalogFilterInput>;
};


export type QueryCatalogsByCityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CatalogSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CatalogFilterInput>;
};


export type QueryCatalogsByIdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  ids: Array<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CatalogSortInput>>;
  where?: InputMaybe<CatalogFilterInput>;
};


export type QueryCatalogsByLatLonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  order?: InputMaybe<Array<CatalogSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CatalogFilterInput>;
};


export type QueryCatalogsCategoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CatalogSortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CatalogFilterInput>;
};


export type QueryCatalogsNoCityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CatalogSortInput>>;
  search: Scalars['String'];
  where?: InputMaybe<CatalogFilterInput>;
};


export type QueryCatalogsRelatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CatalogSortInput>>;
  pageType: Scalars['String'];
  retailerFirst?: Scalars['Boolean'];
  search: Scalars['String'];
  where?: InputMaybe<CatalogFilterInput>;
};


export type QueryCatalogsSpecialsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CatalogSortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CatalogFilterInput>;
};


export type QueryCatalogsTrendingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CatalogSortInput>>;
  pageType: Scalars['String'];
  search: Scalars['String'];
  where?: InputMaybe<CatalogFilterInput>;
};


export type QueryCategoriesArgs = {
  city?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryCategoriesAllArgs = {
  order?: InputMaybe<Array<CategorySortInput>>;
};


export type QueryCategoriesTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryArgs = {
  search: Scalars['String'];
};


export type QueryCategoryByIdArgs = {
  id: Scalars['Int'];
};


export type QueryCategoryByNameArgs = {
  name: Scalars['String'];
};


export type QueryCategoryTagsArgs = {
  categoryId: Scalars['Int'];
};


export type QueryCitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CitySortInput>>;
};


export type QueryCityArgs = {
  search: Scalars['String'];
};


export type QueryCustomizationsArgs = {
  context: Scalars['String'];
  integration: Scalars['String'];
};


export type QueryDescriptionArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryFaqArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryFooterArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryHighLightedArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryHighLightedCitiesArgs = {
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryHighLightedSeasonalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SeasonalSortInput>>;
  where?: InputMaybe<SeasonalFilterInput>;
};


export type QueryInternationalSitesArgs = {
  order?: InputMaybe<Array<LinkSortInput>>;
};


export type QueryLaunchViewerArgs = {
  input: LaunchViewerInput;
};


export type QueryLeftMenuArgs = {
  city: Scalars['String'];
  filter: Scalars['String'];
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryLeftMenuByLatLonArgs = {
  filter: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryLeftMenuStoreDetailArgs = {
  storeId: Scalars['Int'];
};


export type QueryLinkViewerArgs = {
  input: LinkViewerInput;
};


export type QueryLinksRetailersArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryLinksRetailersStoreDetailArgs = {
  storeId: Scalars['Int'];
};


export type QueryMallArgs = {
  search: Scalars['String'];
};


export type QueryMallByIdArgs = {
  id: Scalars['Int'];
};


export type QueryMallByNameArgs = {
  name: Scalars['String'];
};


export type QueryMallInfoArgs = {
  search: Scalars['String'];
};


export type QueryMallsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MallSortInput>>;
};


export type QueryMetatagsArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  integration?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryMetatagsStoreDetailArgs = {
  storeId: Scalars['Int'];
};


export type QueryNavigationLinksArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryNavigationLinksStoreDetailArgs = {
  storeId: Scalars['Int'];
};


export type QueryNearestCitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CitySortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryNearestCityArgs = {
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};


export type QueryNearestMallsByCityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  distance: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MallSortInput>>;
};


export type QueryNearestMallsByLatLonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  distance: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  order?: InputMaybe<Array<MallSortInput>>;
};


export type QueryNearestStoresArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<StoreSortInput>>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryNearestStoresByCityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<StoreSortInput>>;
  storeId: Scalars['Int'];
};


export type QueryNearestStoresByLatLonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  order?: InputMaybe<Array<StoreSortInput>>;
  storeId: Scalars['Int'];
};


export type QueryNearestStoresByStoreArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<StoreSortInput>>;
  storeId: Scalars['Int'];
};


export type QueryOfferArgs = {
  id: Scalars['Int'];
  type: OfferType;
};


export type QueryOfferCatalogPageArgs = {
  catalogId: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryOfferProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OfferProductSortInput>>;
  pageType: Scalars['String'];
  search: Scalars['String'];
  where?: InputMaybe<OfferProductFilterInput>;
};


export type QueryOfferTagBoxArgs = {
  id: Scalars['String'];
};


export type QueryOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OfferSortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<OfferFilterInput>;
};


export type QueryOffersByCatalogArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalogId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OfferSortInput>>;
  where?: InputMaybe<OfferFilterInput>;
};


export type QueryOffersRelatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalogId: Scalars['Int'];
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OfferSortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<OfferFilterInput>;
};


export type QueryPageInfoArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  integration?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryPageInfoStoreDetailArgs = {
  storeId: Scalars['Int'];
};


export type QueryRetailerArgs = {
  search: Scalars['String'];
};


export type QueryRetailerByIdArgs = {
  id: Scalars['Int'];
};


export type QueryRetailerByNameArgs = {
  name: Scalars['String'];
};


export type QueryRetailersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<RetailerSortInput>>;
  where?: InputMaybe<RetailerFilterInput>;
};


export type QuerySeasonalArgs = {
  search: Scalars['String'];
};


export type QuerySeasonalByIdArgs = {
  id: Scalars['Int'];
};


export type QuerySeasonalByNameArgs = {
  name: Scalars['String'];
};


export type QuerySeasonalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SeasonalSortInput>>;
  where?: InputMaybe<SeasonalFilterInput>;
};


export type QueryShoppingListOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OfferSortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryShoppingListOffersProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<LinkSortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySitemapArgs = {
  type: SitemapType;
};


export type QuerySliderPageInfoArgs = {
  input: SliderPageInfoInput;
};


export type QuerySliderScriptInfoArgs = {
  input: SliderScriptInfoInput;
};


export type QuerySpecialProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<LinkSortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<LinkFilterInput>;
};


export type QueryStatsDataArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryStoreArgs = {
  id: Scalars['Int'];
};


export type QueryStoresArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<StoreSortInput>>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryStoresByCatalogArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalogId: Scalars['Int'];
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<StoreSortInput>>;
};


export type QueryStoresByCatalogLatLonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalogId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  order?: InputMaybe<Array<StoreSortInput>>;
};


export type QueryStoresByCityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<StoreSortInput>>;
  search: Scalars['String'];
};


export type QueryStoresByLatLonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  order?: InputMaybe<Array<StoreSortInput>>;
  search: Scalars['String'];
};


export type QueryStoresNoCityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};


export type QueryTabsArgs = {
  city?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryTagBoxOffersByCatalogArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalogId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OfferTagBoxSortInput>>;
  pageNumbers?: InputMaybe<Array<Scalars['Int']>>;
  where?: InputMaybe<OfferTagBoxFilterInput>;
};


export type QueryTagBrandArgs = {
  search: Scalars['String'];
};


export type QueryTagBrandByIdArgs = {
  id: Scalars['Int'];
};


export type QueryTagBrandByNameArgs = {
  name: Scalars['String'];
};


export type QueryTagProductArgs = {
  search: Scalars['String'];
};


export type QueryTagProductByIdArgs = {
  id: Scalars['Int'];
};


export type QueryTagProductByNameArgs = {
  name: Scalars['String'];
};


export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TagSortInput>>;
};


export type QueryTiendeoInYourCityArgs = {
  city: Scalars['String'];
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTopCitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CitySortInput>>;
  pageType: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTopMallsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MallSortInput>>;
};


export type QueryTopMallsByLatLonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  order?: InputMaybe<Array<MallSortInput>>;
};


export type QueryTopTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TagSortInput>>;
};


export type QueryUrlArgs = {
  city?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pageType: Scalars['String'];
  search: Scalars['String'];
};


export type QueryUrlByCityArgs = {
  city?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
};


export type QueryUrlByLatLonArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  search: Scalars['String'];
};


export type QueryUrlStoreDetailArgs = {
  storeId: Scalars['Int'];
};

export type Retailer = {
  __typename?: 'Retailer';
  affinity: Scalars['Int'];
  categories?: Maybe<Array<Scalars['Int']>>;
  category?: Maybe<Category>;
  categoryId: Scalars['Int'];
  defaultCity: Scalars['Int'];
  hasOffers: Scalars['Boolean'];
  id: Scalars['Int'];
  isManufacturer: Scalars['Boolean'];
  isOpenArticleInNewWindow: Scalars['Boolean'];
  link?: Maybe<Link>;
  logo: Scalars['String'];
  logo2: Scalars['String'];
  logoHeight: Scalars['Int'];
  logoWidth: Scalars['Int'];
  marker: Scalars['String'];
  maxDistance: Scalars['Int'];
  moreCatalogs: Scalars['Int'];
  name: Scalars['String'];
  numberOfStores: Scalars['Int'];
  offersInfoText: Scalars['String'];
  onlyOnline: Scalars['Boolean'];
  seoName: Scalars['String'];
  shopfullyId: Scalars['Int'];
  showAdvertising: Scalars['Boolean'];
  storesOnly: Scalars['Boolean'];
  top: Scalars['Int'];
  typeNoCity: Scalars['Int'];
  urlEcommerce?: Maybe<Scalars['String']>;
  urlForStoreDetail?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type RetailerConnection = {
  __typename?: 'RetailerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RetailerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Retailer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type RetailerEdge = {
  __typename?: 'RetailerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Retailer;
};

export type RetailerFilterInput = {
  affinity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<RetailerFilterInput>>;
  categories?: InputMaybe<ListIntOperationFilterInput>;
  category?: InputMaybe<CategoryFilterInput>;
  categoryId?: InputMaybe<IntOperationFilterInput>;
  defaultCity?: InputMaybe<IntOperationFilterInput>;
  hasOffers?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isManufacturer?: InputMaybe<BooleanOperationFilterInput>;
  isOpenArticleInNewWindow?: InputMaybe<BooleanOperationFilterInput>;
  logo?: InputMaybe<StringOperationFilterInput>;
  logo2?: InputMaybe<StringOperationFilterInput>;
  logoHeight?: InputMaybe<IntOperationFilterInput>;
  logoWidth?: InputMaybe<IntOperationFilterInput>;
  marker?: InputMaybe<StringOperationFilterInput>;
  maxDistance?: InputMaybe<IntOperationFilterInput>;
  moreCatalogs?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberOfStores?: InputMaybe<IntOperationFilterInput>;
  offersInfoText?: InputMaybe<StringOperationFilterInput>;
  onlyOnline?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<RetailerFilterInput>>;
  seoName?: InputMaybe<StringOperationFilterInput>;
  shopfullyId?: InputMaybe<IntOperationFilterInput>;
  showAdvertising?: InputMaybe<BooleanOperationFilterInput>;
  storesOnly?: InputMaybe<BooleanOperationFilterInput>;
  top?: InputMaybe<IntOperationFilterInput>;
  typeNoCity?: InputMaybe<IntOperationFilterInput>;
  urlEcommerce?: InputMaybe<StringOperationFilterInput>;
  urlForStoreDetail?: InputMaybe<StringOperationFilterInput>;
  web?: InputMaybe<StringOperationFilterInput>;
};

export type RetailerSortInput = {
  affinity?: InputMaybe<SortEnumType>;
  category?: InputMaybe<CategorySortInput>;
  categoryId?: InputMaybe<SortEnumType>;
  defaultCity?: InputMaybe<SortEnumType>;
  hasOffers?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isManufacturer?: InputMaybe<SortEnumType>;
  isOpenArticleInNewWindow?: InputMaybe<SortEnumType>;
  logo?: InputMaybe<SortEnumType>;
  logo2?: InputMaybe<SortEnumType>;
  logoHeight?: InputMaybe<SortEnumType>;
  logoWidth?: InputMaybe<SortEnumType>;
  marker?: InputMaybe<SortEnumType>;
  maxDistance?: InputMaybe<SortEnumType>;
  moreCatalogs?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  numberOfStores?: InputMaybe<SortEnumType>;
  offersInfoText?: InputMaybe<SortEnumType>;
  onlyOnline?: InputMaybe<SortEnumType>;
  seoName?: InputMaybe<SortEnumType>;
  shopfullyId?: InputMaybe<SortEnumType>;
  showAdvertising?: InputMaybe<SortEnumType>;
  storesOnly?: InputMaybe<SortEnumType>;
  top?: InputMaybe<SortEnumType>;
  typeNoCity?: InputMaybe<SortEnumType>;
  urlEcommerce?: InputMaybe<SortEnumType>;
  urlForStoreDetail?: InputMaybe<SortEnumType>;
  web?: InputMaybe<SortEnumType>;
};

export type RobotsTxt = {
  __typename?: 'RobotsTxt';
  disallows: Array<Scalars['String']>;
};

export type SavedPageInput = {
  catalogId: Scalars['Int'];
  page: Scalars['Int'];
};

export type Search = {
  __typename?: 'Search';
  contentType?: Maybe<Scalars['String']>;
  groupSearch: Scalars['Boolean'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  seoName?: Maybe<Scalars['String']>;
  type: SearchType;
};

export type SearchFromUrl = {
  __typename?: 'SearchFromUrl';
  category?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SearchInfo = {
  __typename?: 'SearchInfo';
  tag?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
};

export type SearchInfoFilterInput = {
  and?: InputMaybe<Array<SearchInfoFilterInput>>;
  or?: InputMaybe<Array<SearchInfoFilterInput>>;
  tag?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type SearchInfoSortInput = {
  tag?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum SearchType {
  Brand = 'BRAND',
  Cashback = 'CASHBACK',
  Category = 'CATEGORY',
  City = 'CITY',
  CustomSearch = 'CUSTOM_SEARCH',
  Deals = 'DEALS',
  Mall = 'MALL',
  Product = 'PRODUCT',
  Province = 'PROVINCE',
  Retailer = 'RETAILER',
  Seasonal = 'SEASONAL',
  Suburb = 'SUBURB'
}

export type Seasonal = {
  __typename?: 'Seasonal';
  acronym: Scalars['String'];
  id: Scalars['Int'];
  link?: Maybe<Link>;
  name: Scalars['String'];
  order: Scalars['Int'];
  seoName: Scalars['String'];
  visible: Scalars['Boolean'];
};

/** A connection to a list of items. */
export type SeasonalConnection = {
  __typename?: 'SeasonalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SeasonalEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Seasonal>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SeasonalEdge = {
  __typename?: 'SeasonalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Seasonal;
};

export type SeasonalFilterInput = {
  acronym?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<SeasonalFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SeasonalFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  seoName?: InputMaybe<StringOperationFilterInput>;
  visible?: InputMaybe<BooleanOperationFilterInput>;
};

export type SeasonalSortInput = {
  acronym?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  seoName?: InputMaybe<SortEnumType>;
  visible?: InputMaybe<SortEnumType>;
};

export type Section = {
  __typename?: 'Section';
  catalogId: Scalars['Int'];
  categoryId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  page: Scalars['Int'];
};

export type SectionFilterInput = {
  and?: InputMaybe<Array<SectionFilterInput>>;
  catalogId?: InputMaybe<IntOperationFilterInput>;
  categoryId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SectionFilterInput>>;
  page?: InputMaybe<IntOperationFilterInput>;
};

export type SitemapItem = {
  __typename?: 'SitemapItem';
  change: Scalars['String'];
  lastModification: Scalars['String'];
  priority: Scalars['String'];
  url: Scalars['String'];
};

export enum SitemapType {
  Categories = 'CATEGORIES',
  Cities = 'CITIES',
  Products = 'PRODUCTS',
  Retailers = 'RETAILERS',
  Retailerscity = 'RETAILERSCITY'
}

export type SliderCatalog = {
  __typename?: 'SliderCatalog';
  promo?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SliderHtmls = {
  __typename?: 'SliderHtmls';
  footer?: Maybe<Scalars['String']>;
  head?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
};

export type SliderIntegrationRetailer = {
  __typename?: 'SliderIntegrationRetailer';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  seoName?: Maybe<Scalars['String']>;
};

export type SliderPageInfoInput = {
  catalogId?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  integration?: InputMaybe<Scalars['String']>;
  openCatalog?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  selectedCustomer?: InputMaybe<Scalars['Int']>;
  shopfullyCatalogId?: InputMaybe<Scalars['Int']>;
  storeCustomer?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['Int']>;
  uData?: InputMaybe<Scalars['String']>;
};

export type SliderPageInfoOutput = {
  __typename?: 'SliderPageInfoOutput';
  catalogId?: Maybe<Scalars['String']>;
  configs?: Maybe<Scalars['Any']>;
  integrationCustomers?: Maybe<Array<SliderIntegrationRetailer>>;
  integrationName?: Maybe<Scalars['String']>;
  integrations?: Maybe<Scalars['Any']>;
  origin?: Maybe<Scalars['String']>;
  searchCategory?: Maybe<Scalars['String']>;
  searchFromUrl?: Maybe<SearchFromUrl>;
  searchName?: Maybe<Scalars['String']>;
  selectedCustomer?: Maybe<Scalars['Int']>;
  statsData?: Maybe<SliderStatsData>;
  storeId?: Maybe<Scalars['Int']>;
  texts?: Maybe<Scalars['Any']>;
};

export type SliderScriptInfoInput = {
  catalogId?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  integration?: InputMaybe<Scalars['String']>;
  integrationName?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  openCatalog?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  selectedCustomer?: InputMaybe<Scalars['Int']>;
  shopfullyCatalogId?: InputMaybe<Scalars['Int']>;
  storeCustomer?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['Int']>;
};

export type SliderScriptInfoOutput = {
  __typename?: 'SliderScriptInfoOutput';
  catalogId?: Maybe<Scalars['String']>;
  /** @deprecated Use other SliderScriptInfoOutput fiels instead */
  customizations?: Maybe<Scalars['Any']>;
  integrationName: Scalars['String'];
  integrations?: Maybe<Scalars['Any']>;
  searchCategory?: Maybe<Scalars['String']>;
  searchName?: Maybe<Scalars['String']>;
  selectedCustomer?: Maybe<Scalars['Int']>;
};

export type SliderStatsData = {
  __typename?: 'SliderStatsData';
  origin?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};

export type SliderStore = {
  __typename?: 'SliderStore';
  title?: Maybe<Scalars['String']>;
};

export type SliderStoreCatalog = {
  __typename?: 'SliderStoreCatalog';
  catalogImageUrl?: Maybe<Scalars['String']>;
  catalogPromoUrl?: Maybe<Scalars['String']>;
  catalogViewerUrl?: Maybe<Scalars['String']>;
  formattedPromo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatsData = {
  __typename?: 'StatsData';
  city?: Maybe<City>;
  filter?: Maybe<Search>;
  numCatalogs: Scalars['Int'];
  numDynamics: Scalars['Int'];
  numExpireds: Scalars['Int'];
  numGroup: Scalars['Int'];
  numOnlyOnline: Scalars['Int'];
  numRecommendeds: Scalars['Int'];
  numResults: Scalars['Int'];
  numSales: Scalars['Int'];
  numTagPages: Scalars['Int'];
  numTagboxes: Scalars['Int'];
  search?: Maybe<Search>;
};

export type StatsMetadata = {
  __typename?: 'StatsMetadata';
  et: Scalars['Float'];
  st: Scalars['String'];
  ts: Scalars['String'];
};

export type Store = {
  __typename?: 'Store';
  address: Scalars['String'];
  catalogs?: Maybe<Array<Catalog>>;
  city: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  distance: Scalars['Float'];
  email?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  hasOffers: Scalars['Boolean'];
  id: Scalars['Int'];
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  mall?: Maybe<Mall>;
  mallId: Scalars['Int'];
  mallName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  realCity?: Maybe<Scalars['String']>;
  retailer?: Maybe<Retailer>;
  retailerId: Scalars['Int'];
  retailerName: Scalars['String'];
  schedules?: Maybe<Array<StoreSchedule>>;
  searchInfo?: Maybe<SearchInfo>;
  seoAddress?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  url?: Maybe<Link>;
  urlInWebRetailer?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['String']>;
  webStores?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type StoreConnection = {
  __typename?: 'StoreConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StoreEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Store>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type StoreEdge = {
  __typename?: 'StoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Store;
};

export type StoreNoCity = {
  __typename?: 'StoreNoCity';
  city?: Maybe<City>;
  link?: Maybe<Link>;
  stores?: Maybe<StoreConnection>;
};


export type StoreNoCityStoresArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type StoreNoCityConnection = {
  __typename?: 'StoreNoCityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StoreNoCityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<StoreNoCity>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type StoreNoCityEdge = {
  __typename?: 'StoreNoCityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: StoreNoCity;
};

export type StoreSchedule = {
  __typename?: 'StoreSchedule';
  closingHour: Scalars['Int'];
  closingMinute: Scalars['Int'];
  day: Scalars['Int'];
  openingHour: Scalars['Int'];
  openingMinute: Scalars['Int'];
};

export type StoreSortInput = {
  address?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  distance?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  externalUrl?: InputMaybe<SortEnumType>;
  hasOffers?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lat?: InputMaybe<SortEnumType>;
  lon?: InputMaybe<SortEnumType>;
  mall?: InputMaybe<MallSortInput>;
  mallId?: InputMaybe<SortEnumType>;
  mallName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  postalCode?: InputMaybe<SortEnumType>;
  province?: InputMaybe<SortEnumType>;
  realCity?: InputMaybe<SortEnumType>;
  retailer?: InputMaybe<RetailerSortInput>;
  retailerId?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  searchInfo?: InputMaybe<SearchInfoSortInput>;
  seoAddress?: InputMaybe<SortEnumType>;
  suburb?: InputMaybe<SortEnumType>;
  url?: InputMaybe<LinkSortInput>;
  urlInWebRetailer?: InputMaybe<SortEnumType>;
  web?: InputMaybe<SortEnumType>;
  webStores?: InputMaybe<SortEnumType>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Suburb = {
  __typename?: 'Suburb';
  id: Scalars['Int'];
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  name: Scalars['String'];
  seoName: Scalars['String'];
};

export type Synonym = {
  __typename?: 'Synonym';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type SynonymFilterInput = {
  and?: InputMaybe<Array<SynonymFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SynonymFilterInput>>;
};

export type SynonymSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Tag = {
  __typename?: 'Tag';
  category?: Maybe<Category>;
  categoryId: Scalars['Int'];
  id: Scalars['Int'];
  index: Scalars['Boolean'];
  isManufacturer: Scalars['Boolean'];
  link?: Maybe<Link>;
  male: Scalars['Boolean'];
  name: Scalars['String'];
  seoName: Scalars['String'];
  singular: Scalars['Boolean'];
  top: Scalars['Int'];
  type: SearchType;
};

export type TagBox = {
  __typename?: 'TagBox';
  areaId: Scalars['Int'];
  buttonText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  extraTitle?: Maybe<Scalars['String']>;
  finalUnitPrice: Scalars['Float'];
  free: Scalars['Boolean'];
  highlightedText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  images?: Maybe<Array<Scalars['String']>>;
  legalText?: Maybe<Scalars['String']>;
  localOffer?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  price?: Maybe<Scalars['String']>;
  priceContext?: Maybe<Scalars['String']>;
  promoCouponId: Scalars['Int'];
  promoCouponType: Scalars['Int'];
  promotion?: Maybe<Scalars['String']>;
  quantity1: Scalars['Float'];
  quantity2: Scalars['Float'];
  secondUnitPrice: Scalars['Float'];
  section?: Maybe<Scalars['String']>;
  shipping?: Maybe<Scalars['String']>;
  shopfullyId: Scalars['String'];
  shortLegalText?: Maybe<Scalars['String']>;
  stringId?: Maybe<Scalars['String']>;
  tagId: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['Int'];
  unit?: Maybe<Scalars['String']>;
  unitPrice: Scalars['Float'];
  url?: Maybe<Scalars['String']>;
  x1: Scalars['Decimal'];
  x2: Scalars['Decimal'];
  y1: Scalars['Decimal'];
  y2: Scalars['Decimal'];
};

export type TagBoxPoint = {
  __typename?: 'TagBoxPoint';
  x: Scalars['Decimal'];
  y: Scalars['Decimal'];
};

export type TagBoxPointFilterInput = {
  and?: InputMaybe<Array<TagBoxPointFilterInput>>;
  or?: InputMaybe<Array<TagBoxPointFilterInput>>;
  x?: InputMaybe<DecimalOperationFilterInput>;
  y?: InputMaybe<DecimalOperationFilterInput>;
};

export type TagBoxPointSortInput = {
  x?: InputMaybe<SortEnumType>;
  y?: InputMaybe<SortEnumType>;
};

export type TagBoxPromoCouponInfo = {
  __typename?: 'TagBoxPromoCouponInfo';
  id: Scalars['Int'];
  type: Scalars['Int'];
};

export type TagBoxPromoCouponInfoFilterInput = {
  and?: InputMaybe<Array<TagBoxPromoCouponInfoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<TagBoxPromoCouponInfoFilterInput>>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type TagBoxPromoCouponInfoSortInput = {
  id?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum TagBoxType {
  Banner = 'BANNER',
  Gift = 'GIFT',
  Hidden = 'HIDDEN',
  LoyaltyCard = 'LOYALTY_CARD',
  OnlineSale = 'ONLINE_SALE',
  Page = 'PAGE',
  Pixel = 'PIXEL',
  Point = 'POINT',
  Print = 'PRINT',
  Product = 'PRODUCT',
  Undefined = 'UNDEFINED',
  Video = 'VIDEO'
}

export type TagBoxTypeOperationFilterInput = {
  eq?: InputMaybe<TagBoxType>;
  in?: InputMaybe<Array<TagBoxType>>;
  neq?: InputMaybe<TagBoxType>;
  nin?: InputMaybe<Array<TagBoxType>>;
};

export type TagBrand = {
  __typename?: 'TagBrand';
  brand?: Maybe<Tag>;
  relatedBrands?: Maybe<Array<Tag>>;
  relatedProducts?: Maybe<Array<Tag>>;
};

/** A connection to a list of items. */
export type TagConnection = {
  __typename?: 'TagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TagEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Tag>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TagEdge = {
  __typename?: 'TagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Tag;
};

export type TagProduct = {
  __typename?: 'TagProduct';
  product?: Maybe<Tag>;
  relatedBrands?: Maybe<Array<Tag>>;
};

export type TagSortInput = {
  categoryId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  index?: InputMaybe<SortEnumType>;
  isManufacturer?: InputMaybe<SortEnumType>;
  male?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  seoName?: InputMaybe<SortEnumType>;
  singular?: InputMaybe<SortEnumType>;
  top?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type TiendeoInYourCity = {
  __typename?: 'TiendeoInYourCity';
  cities?: Maybe<Array<LinkGroup>>;
  title?: Maybe<Scalars['String']>;
};

export enum UserDataAction {
  Delete = 'DELETE',
  Extract = 'EXTRACT'
}

export type AlertsEmailFragment = { __typename?: 'AlertsEmail', newsletter: boolean, email?: string | null, hash?: string | null, alerts?: Array<{ __typename?: 'Alert', id: number, search?: string | null, city?: string | null } | null> | null };

export type AutocompleteItemFragment = { __typename?: 'AutocompleteItem', id: number, name: string, seoName: string, type: number };

export type AutocompleteProductFragment = { __typename?: 'AutocompleteProduct', name: string, id: number };

export type CatalogFragment = { __typename?: 'Catalog', id: number, title: string, imageTemplate: string, modelName?: string | null, category?: { __typename?: 'Synonym', name: string } | null, retailer?: { __typename?: 'Retailer', id: number, logo2: string, name: string } | null };

export type CategoryFragment = { __typename?: 'Category', id: number, imageUrl: string, name: string, shortName: string };

export type RetailerConnectionFragment = { __typename?: 'RetailerConnection', totalCount: number, nodes?: Array<{ __typename?: 'Retailer', id: number, name: string, logo2: string }> | null };

export type ConfirmAlertsMutationVariables = Exact<{
  hash: Scalars['String'];
  user: Scalars['String'];
}>;


export type ConfirmAlertsMutation = { __typename?: 'Mutation', ConfirmAlerts: boolean };

export type CreateAlertsMutationVariables = Exact<{
  input: CreateAlertsInput;
}>;


export type CreateAlertsMutation = { __typename?: 'Mutation', CreateAlerts: boolean };

export type DeleteAlertsMutationVariables = Exact<{
  input: Array<DeleteAlertInput> | DeleteAlertInput;
  reason?: InputMaybe<Scalars['Int']>;
}>;


export type DeleteAlertsMutation = { __typename?: 'Mutation', DeleteAlerts: boolean };

export type DeleteSavedPageMutationVariables = Exact<{
  input: SavedPageInput;
}>;


export type DeleteSavedPageMutation = { __typename?: 'Mutation', DeleteSavedPage: boolean };

export type DeleteUserAppMutationVariables = Exact<{
  appUserId: Scalars['Long'];
}>;


export type DeleteUserAppMutation = { __typename?: 'Mutation', DeleteUserApp: boolean };

export type NewsletterUpdateMutationVariables = Exact<{
  activate: Scalars['Boolean'];
  hash: Scalars['String'];
}>;


export type NewsletterUpdateMutation = { __typename?: 'Mutation', NewsletterState: boolean };

export type NotifyUserDataMutationVariables = Exact<{
  action: UserDataAction;
  mail: Scalars['String'];
}>;


export type NotifyUserDataMutation = { __typename?: 'Mutation', NotifyUserData: boolean };

export type UserDataMutationVariables = Exact<{
  action: UserDataAction;
  hash: Scalars['String'];
  usuTiendeo: Scalars['String'];
}>;


export type UserDataMutation = { __typename?: 'Mutation', UserData: boolean };

export type AlertsQueryVariables = Exact<{
  hash: Scalars['String'];
}>;


export type AlertsQuery = { __typename?: 'Query', Alerts?: { __typename?: 'AlertsEmail', newsletter: boolean, email?: string | null, hash?: string | null, alerts?: Array<{ __typename?: 'Alert', id: number, search?: string | null, city?: string | null } | null> | null } | null };

export type AutoCompleteCityQueryVariables = Exact<{
  maxResults?: InputMaybe<Scalars['Int']>;
  phrase: Scalars['String'];
}>;


export type AutoCompleteCityQuery = { __typename?: 'Query', AutocompleteCity: Array<{ __typename?: 'AutocompleteItem', id: number, name: string, seoName: string, type: number }> };

export type AutocompleteProductQueryVariables = Exact<{
  maxResults?: InputMaybe<Scalars['Int']>;
  phrase: Scalars['String'];
}>;


export type AutocompleteProductQuery = { __typename?: 'Query', AutocompleteProduct: Array<{ __typename?: 'AutocompleteProduct', name: string, id: number }> };

export type GetCatalogsByIdsQueryVariables = Exact<{
  catalogsIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetCatalogsByIdsQuery = { __typename?: 'Query', CatalogsByIds?: { __typename?: 'CatalogConnection', nodes?: Array<{ __typename?: 'Catalog', id: number, title: string, imageTemplate: string, modelName?: string | null, category?: { __typename?: 'Synonym', name: string } | null, retailer?: { __typename?: 'Retailer', id: number, logo2: string, name: string } | null }> | null } | null };

export type GetNotificationsByHashQueryVariables = Exact<{
  hash: Scalars['String'];
}>;


export type GetNotificationsByHashQuery = { __typename?: 'Query', Alerts?: { __typename?: 'AlertsEmail', newsletter: boolean, email?: string | null, hash?: string | null, alerts?: Array<{ __typename?: 'Alert', id: number, search?: string | null, city?: string | null } | null> | null } | null };

export type GetRetailersByIdQueryVariables = Exact<{
  city: Scalars['String'];
  categoryId?: InputMaybe<Scalars['Int']>;
}>;


export type GetRetailersByIdQuery = { __typename?: 'Query', Retailers?: { __typename?: 'RetailerConnection', totalCount: number, nodes?: Array<{ __typename?: 'Retailer', id: number, name: string, logo2: string }> | null } | null };

export type GetTopRetailersQueryVariables = Exact<{
  city: Scalars['String'];
}>;


export type GetTopRetailersQuery = { __typename?: 'Query', Retailers?: { __typename?: 'RetailerConnection', totalCount: number, nodes?: Array<{ __typename?: 'Retailer', id: number, name: string, logo2: string }> | null } | null };

export type NotificationsPageQueryVariables = Exact<{
  city: Scalars['String'];
}>;


export type NotificationsPageQuery = { __typename?: 'Query', Retailers?: { __typename?: 'RetailerConnection', totalCount: number, nodes?: Array<{ __typename?: 'Retailer', id: number, name: string, logo2: string }> | null } | null, CategoriesAll: Array<{ __typename?: 'Category', id: number, imageUrl: string, name: string, shortName: string }> };
